import { FaDumbbell } from "react-icons/fa";

function LeftFoot
    ()
{
    return (
        <div>
            <div className="flex flex-col mx-24 my-4">
                <div className="flex items-center">F
                    <FaDumbbell className="fill-white rotate-90" />
                    TNESS</div>
                <div>TRACKER</div>
                <div className="w-80 mt-4 text-lg">Our React-based web app helps users track workouts, create new sessions, and access detailed analytics. It offers personalized insights to optimize fitness routines and support progress, making it easier to stay motivated and achieve fitness goals.</div>
            </div>
        </div>
    );
}

export default LeftFoot
    ;